export default "__VITE_ASSET__BSCIuOCY__"